'use client'

import { ButtonContentLink } from '@fukku/button/ContentLink/ButtonContentLink'
import textHeadingL from '@fukku/styles/texts/textHeadingL.module.css'
import { cx } from 'classix'
import { useCookiesCompliance } from 'cookies/hooks/useCookiesCompliance/useCookiesCompliance'
import { useCookiesContext } from 'cookies/hooks/useCookiesContext/useCookiesContext'
import { ButtonType } from 'cookies/types'
import { ClientLabel } from 'labels/components/ClientLabel/ClientLabel'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { CookiesFooter } from './CookiesFooter/CookiesFooter'
import styles from './CookiesNotice.module.css'

export const CookiesNotice = () => {
	const { t } = useLabels()
	const { buttonsConfiguration } = useCookiesContext()
	const { rejectAllCookies } = useCookiesCompliance()
	const { rejectAll } = buttonsConfiguration

	const placeholderValues = {
		linkHere: '/privacy-policy#cookies', // TODO delete after publishing key in all env
		PrivacyPolicyCookies: '/privacy-policy#cookies',
	}

	return (
		<div className={styles.cookiesNotice}>
			<div className={styles.cookiesNoticeContent}>
				{rejectAll.firstLevel && rejectAll.type === ButtonType.Link && (
					<ButtonContentLink
						className={styles.rejectFirstLevel}
						onClick={rejectAllCookies}
						data-testid='cookies.button.rejectAll'
					>
						{t('cookies.configuration.continueWithoutAccept.link')}
					</ButtonContentLink>
				)}
				<h2
					id='cbanner-title'
					className={cx(styles.cookiesTitle, textHeadingL.className)}
				>
					<ClientLabel
						italicProps={{
							className: cx(styles.italic, textHeadingL.className),
						}}
					>
						{t('cookiesBanner.title')}
					</ClientLabel>
				</h2>
				<div className={styles.cookiesPolicy}>
					<ClientLabel placeholderValues={placeholderValues}>
						{t('cookies.banner.bodycopy')}
					</ClientLabel>
				</div>

				<CookiesFooter />
			</div>
		</div>
	)
}
